﻿import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FacebookLoginButton from './Facebook/FacebookLoginButton.jsx';
import GoogleLoginButton from './Google/GoogleLoginButton.jsx';
import './styles/LogInForm.css';
import '../Shared/components/styles/CustomTextInput.css';
import AuthMainImage from './AuthMainImage.jsx';
import {CustomButton} from "../Shared/components/CustomButton.jsx";

export default function LogInForm(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({ email: '', password: '', general: '' });
    const [isHidePassword, setIsHidePassword] = useState(false);
    const navigate = useNavigate();

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,253}$/;
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        const passwordRegex = /^.{8,64}$/;
        return passwordRegex.test(password);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        localStorage.setItem('loginEmail', e.target.value);
        setErrors({ ...errors, email: '' });
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setErrors({ ...errors, password: '' });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let valid = true;

        if (!validateEmail(email)) {
            setErrors((prevErrors) => ({ ...prevErrors, email: 'Invalid email address' }));
            valid = false;
        }

        if (!validatePassword(password)) {
            setErrors((prevErrors) => ({ ...prevErrors, password: 'Password must be at least 8 characters long' }));
            valid = false;
        }

        if (valid) {
            props.handleSubmit({ email, password });
        }
    };

    useEffect(() => {
        if (props.error) {
            const newError = { ...errors };
            newError[props.error.type] = props.error.message;
            setErrors(newError);
        }
    }, [props.error]);

    const goToForgotPasswordPage = () => {
        if (props.fullPageNavigation) {
            window.location.assign('/recover-password');
        } else {
            navigate('/recover-password');
        }
    }

    function onPasswordButtonClick() {
        setIsHidePassword(!isHidePassword)
    }

    return (
        <div className="login-container main center-items">
            <form className="auth-form" onSubmit={handleSubmit}>
                <div className="auth-form__header mobile">
                    <h2>Sign In</h2>
                    <p>Sign in to your account</p>
                </div>
                <div className="main-image__wrapper">
                    <AuthMainImage />
                </div>
                <div className="form__wrapper">
                    <div className="auth-form__header desktop">
                        <h2>Sign In</h2>
                        <p>Sign in to your account</p>
                    </div>
                    <div className="form__content">
                        <div className="option-input">
                            <div>Email</div>
                            <div>
                                <div className={"input-form" + (errors.email ? ' error' : '')}>
                                    <input
                                        type="text"
                                        className="auth-input"
                                        placeholder="Enter your email address"
                                        name="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        required
                                    />
                                </div>
                                {errors.email && <div className="auth-error-message">{errors.email}</div>}
                            </div>
                        </div>

                        <div className="option-input">
                            <div>Password</div>
                            <div>
                                <div className={"input-form" + (errors.password ? ' error' : '')}>
                                    <input
                                        type={!isHidePassword ? 'password' : 'text'}
                                        className="auth-input"
                                        placeholder="Password"
                                        name="password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        required
                                    />
                                    <div
                                        className="password-icon"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={isHidePassword ? 'Hide password' : 'Show password'}
                                        aria-pressed={isHidePassword}
                                        onClick={onPasswordButtonClick}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                onPasswordButtonClick();
                                            }
                                        }}
                                    >
                                        <svg className={isHidePassword ? 'hidden': ''} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <circle cx="12" cy="12.5" r="2" stroke="#5A5A5A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M22 12.5C19.333 17.167 16 19.5 12 19.5C8 19.5 4.667 17.167 2 12.5C4.667 7.833 8 5.5 12 5.5C16 5.5 19.333 7.833 22 12.5" stroke="#5A5A5A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <svg className={!isHidePassword ? 'hidden': ''} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M3 3L21 21" stroke="#5A5A5A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M10.5845 10.5869C9.80297 11.3678 9.80252 12.6344 10.5835 13.4159C11.3644 14.1974 12.631 14.1978 13.4125 13.4169" stroke="#5A5A5A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M9.15676 4.64398C8.75852 4.75791 8.52804 5.1731 8.64196 5.57133C8.75588 5.96957 9.17107 6.20006 9.56931 6.08614L9.15676 4.64398ZM12 5.00006L11.9974 5.75006H12V5.00006ZM22 12.0001L22.6512 12.3723C22.783 12.1417 22.783 11.8586 22.6512 11.6279L22 12.0001ZM18.9463 14.979C18.6651 15.2832 18.6838 15.7577 18.988 16.0388C19.2922 16.32 19.7667 16.3013 20.0478 15.9971L18.9463 14.979ZM17.7764 17.9709C18.1198 17.7393 18.2104 17.2731 17.9788 16.9297C17.7472 16.5863 17.281 16.4956 16.9376 16.7273L17.7764 17.9709ZM2 12.0001L1.34887 11.6279C1.21706 11.8585 1.21704 12.1416 1.34883 12.3722L2 12.0001ZM7.05301 7.27974C7.39581 7.04722 7.4852 6.58084 7.25268 6.23805C7.02017 5.89525 6.55378 5.80585 6.21099 6.03837L7.05301 7.27974ZM9.36304 5.36506L9.56931 6.08614C10.3588 5.86029 11.1762 5.74715 11.9974 5.75005L12 5.00006L12.0027 4.25006C11.0402 4.24665 10.0821 4.37927 9.15676 4.64398L9.36304 5.36506ZM12 5.00006V5.75006C15.64 5.75006 18.7632 7.84749 21.3489 12.3722L22 12.0001L22.6512 11.6279C19.9029 6.81863 16.36 4.25006 12 4.25006V5.00006ZM22 12.0001L21.3489 11.6279C20.5937 12.949 19.792 14.064 18.9463 14.979L19.497 15.4881L20.0478 15.9971C20.9841 14.9842 21.8504 13.7731 22.6512 12.3723L22 12.0001ZM17.357 17.3491L16.9376 16.7273C15.4284 17.7451 13.79 18.2501 12 18.2501V19.0001V19.7501C14.094 19.7501 16.0236 19.153 17.7764 17.9709L17.357 17.3491ZM12 19.0001V18.2501C8.36001 18.2501 5.23685 16.1526 2.65117 11.6279L2 12.0001L1.34883 12.3722C4.09715 17.1815 7.63999 19.7501 12 19.7501V19.0001ZM2 12.0001L2.65113 12.3722C3.98114 10.0455 5.45439 8.36409 7.05301 7.27974L6.632 6.65906L6.21099 6.03837C4.37161 7.28603 2.75686 9.16465 1.34887 11.6279L2 12.0001Z" fill="#5A5A5A"/>
                                        </svg>
                                    </div>
                                </div>
                                {errors.password && <div className="auth-error-message">{errors.password}</div>}
                            </div>
                        </div>

                        <div className="forgot-password" onClick={goToForgotPasswordPage}>Forgot password?</div>
                    </div>

                    <CustomButton
                        text="Sign In"
                        type="submit"
                        className="sing-in-button"
                    />

                    <div className="auth-form__footer">
                        <div className="signin-link" onClick={props.onChangeToSignUp}>Don`t have an account? <span>Sign Up</span></div>

                        <div className="form-or">
                            <div className="divider"></div>
                            <p>or</p>
                            <div className="divider"></div>
                        </div>

                        <div className="auth-methods">
                            <GoogleLoginButton returnTo={props.returnTo} />
                            <FacebookLoginButton returnTo={props.returnTo} />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}